/* One-time offer before checkout (bp-co) - 2026-10-28, Ram: "add a screen like the third image that pops up after you press add to
   checkout but already in checkout". Port of Pelsbarn's nextdev--checkout-upsell-modal.js: the first CHECKOUT tap in the cart
   drawer opens a white "checkout is loading" page with the offer sheet on top (2-minute countdown). "Add to Order with Discount"
   adds the Wash Bag (1+1) and goes to checkout; "No thanks" or the countdown ending goes to checkout. Shown once per page view,
   never when the bag is already in the cart, and (Ram 2026-10-28) only when the cooling mat is in the cart: a fountain cart gets no offer. Every exit waits for a cart save still running (window.bpCartWhenIdle,
   bp-cart-pelsbarn.js), so a shopper who tapped the insurance switch a moment earlier still leaves with the right cart.
   Data comes from the [data-bp-co-offer] JSON in snippets/cart-drawer.liquid.
   Tracking (Ram 2026-10-28: "so we know how many people pressed in the cart to go to checkout and then … chose to leave the page
   because of it"): track() beacons tap / shown / add / added / add_fail / decline / timeout / hidden / back / left to the Cloudflare
   worker bp-offer-events (random id per page view, cart total, no personal data). "left" = the page closed or navigated away
   while the offer was open and no choice was made. Read-out: store/checkout-offer-tracking-2026-10-28/report.py.
   Each event also goes to Clarity as a custom event bp_offer_<name>, so the recordings of shoppers who left can be watched. */
(function () {
  'use strict';
  if (window.bpCheckoutOffer) return;
  var shown = false;
  var countdown = null;
  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TRACK_URL = 'https://bp-offer-events.barklypaw.workers.dev/e';
  var sid = Math.random().toString(36).slice(2, 12) + Date.now().toString(36).slice(-4);
  try { if (localStorage.getItem('bp_co_test')) sid = 'zztest' + sid.slice(0, 10); } catch (e) {}  // our own checks; report.py skips them
  var open = false;      // offer on screen
  var decided = false;   // shopper chose add / no thanks, or the countdown ran out

  function cartState() {
    var el = document.querySelector('[data-bp-cart-state]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  function track(name) {
    // Same event into Clarity (app embed, project x7tnkhqal9): recordings filter by event "bp_offer_left" etc.
    try { if (typeof window.clarity === 'function') clarity('event', 'bp_offer_' + name); } catch (e) {}
    try {
      var c = cartState();
      var bv = '', bs = '';  // bp-ux visitor + session ids, so its report can follow this shopper into checkout
      try { bv = localStorage.getItem('_bpv') || ''; bs = (localStorage.getItem('_bps') || '').split('|')[0]; } catch (e) {}
      var body = JSON.stringify({ e: name, s: sid, v: c.total_price, cur: c.currency, bv: bv, bs: bs });
      if (!(navigator.sendBeacon && navigator.sendBeacon(TRACK_URL, body))) {
        fetch(TRACK_URL, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () {});
      }
    } catch (e) {}
  }
  addEventListener('pagehide', function () { if (open && !decided) { open = false; track('left'); } });
  document.addEventListener('visibilitychange', function () {
    if (!open || decided) return;
    track(document.visibilityState === 'hidden' ? 'hidden' : 'back');
  });

  function offer() {
    var el = document.querySelector('[data-bp-co-offer]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function inCart(d) {
    return (cartState().items || []).some(function (i) { return String(i.product_id) === String(d.productId); });
  }
  // Ram 2026-10-28: "i dont want this to pop up for people coming from the fountain cart its only for people in the cooling mat":
  // the offer shows only when the cooling mat (product 10438284247357, facts.json) is in the cart; a fountain-only cart goes
  // straight to checkout (its "tap" is still counted, no "shown").
  var MAT_PRODUCT_ID = '10438284247357';
  function hasMat() {
    return (cartState().items || []).some(function (i) { return String(i.product_id) === MAT_PRODUCT_ID; });
  }
  function wants() {
    var d = offer();
    return !shown && !!d && !!d.available && !inCart(d) && hasMat();
  }
  window.bpCheckoutOffer = { wants: wants };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function whenIdle() { return window.bpCartWhenIdle ? window.bpCartWhenIdle() : Promise.resolve(); }

  var SK = '<i class="t"></i><i class="b"></i><div class="row"><i></i><i></i></div><i class="hr"></i><i class="s"></i><i></i><i></i>' +
           '<i class="hr"></i><i class="s"></i><i></i><i></i>';
  var SPINNER = '<div class="bp-co-modal__spinner hidden"><svg viewBox="0 0 66 66" aria-hidden="true" focusable="false">' +
                '<circle fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

  function backgroundHtml(d) {
    var logo = d.logo ? '<img src="' + esc(d.logo) + '" alt="BarklyPaw">' : '<b>BarklyPaw</b>';
    return '<div class="bp-co-bg hide" data-bp-co-bg>' +
      '<div class="bp-co-bg__header">' + logo + '</div>' +
      '<div class="bp-co-bg__content"><div class="bp-co-bg__main"><div class="bp-co-sk">' + SK + '</div></div>' +
      '<div class="bp-co-bg__side"><div class="bp-co-sk"><i class="b"></i><i></i><i></i><i class="hr"></i><i></i><i></i></div></div></div>' +
      '<div class="bp-co-bg__mobile"><div class="bp-co-bg__line"><i></i><i></i><i></i></div><div class="bp-co-sk">' + SK + '</div></div>' +
      '</div>';
  }
  function modalHtml(d) {
    var compare = d.compare ? '<span class="compare-at-price">' + esc(d.compare) + '</span>' : '';
    var save = d.save > 0 ? '<span class="save">Save ' + esc(d.save) + '%</span>' : '';
    return '<div class="bp-co-modal hide" data-bp-co-modal role="dialog" aria-modal="true" aria-label="Special offer">' +
      '<div class="bp-co-modal__box">' +
        '<div class="bp-co-modal__heading">One-time offer</div>' +
        // Social proof line verbatim from Pelsbarn (Ram 2026-10-28: "i want it just with our name exactly as them yes").
        '<div class="bp-co-modal__sub">Add extra protection for your dog mat while washing (<span style="color:green">save 50%</span>)' +
          '<p style="font-size:14px;color:red">38,768 dog parents have accepted this offer (verified) ✅</p></div>' +
        '<div class="bp-co-modal__countdown"><div>Special Offer Ends In:</div><div class="bp-co-modal__timer">' +
          '<div class="bp-co-modal__block"><div class="bp-co-modal__num" data-bp-co-mm>02</div><div class="bp-co-modal__unit">min</div></div>' +
          '<div class="bp-co-modal__block"><div class="bp-co-modal__num" data-bp-co-ss>00</div><div class="bp-co-modal__unit">sec</div></div>' +
        '</div></div>' +
        '<div class="bp-co-modal__product">' +
          '<div class="bp-co-modal__image"><img src="' + esc(d.image) + '" alt="" width="600" height="600"></div>' +
          '<div class="bp-co-modal__info">' +
            '<div class="bp-co-modal__title">' + esc(d.title) + '</div>' +
            '<div class="bp-co-modal__desc">' + esc(d.description) + '</div>' +
            '<div class="bp-co-modal__price">' + compare + '<span class="price">' + esc(d.price) + '</span>' + save + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="bp-co-modal__buttons">' +
          '<button type="button" class="bp-co-modal__primary" data-bp-co-add><span>Add to Order with Discount</span>' + SPINNER + '</button>' +
          '<button type="button" class="bp-co-modal__secondary" data-bp-co-decline>No thanks, continue to checkout</button>' +
        '</div>' +
      '</div></div>';
  }

  function close() {
    if (countdown) clearInterval(countdown);
    document.querySelectorAll('[data-bp-co-bg],[data-bp-co-modal]').forEach(function (n) { n.remove(); });
    document.documentElement.classList.remove('bp-co-open');
    document.body.classList.remove('bp-co-open');
  }
  // Waits for a running cart save; a cart that could not be confirmed stays in the drawer, which shows its own error.
  function goCheckout() {
    if (countdown) clearInterval(countdown);
    return whenIdle().then(function () { location.assign(routeRoot + 'checkout'); }, close);
  }
  function setLoading(btn, on) {
    btn.classList.toggle('loading', on);
    var sp = btn.querySelector('.bp-co-modal__spinner');
    if (sp) sp.classList.toggle('hidden', !on);
  }
  function add(btn, d) {
    decided = true;
    track('add');
    btn.disabled = true;
    setLoading(btn, true);
    if (countdown) clearInterval(countdown);
    whenIdle().then(function () {
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(d.variantId), quantity: 1 }] })
      }).then(function (res) {
        // /cart/add.js resolves on 422 (sold out etc.): never send the shopper on without the item.
        if (!res.ok) throw new Error('cart/add ' + res.status);
        track('added');
        location.assign(routeRoot + 'checkout');
      });
    }).catch(function () {
      track('add_fail');
      setLoading(btn, false);
      btn.disabled = false;
      var span = btn.querySelector('span');
      if (span) span.textContent = 'Try again';
    });
  }
  function startCountdown(modal, minutes) {
    var mm = modal.querySelector('[data-bp-co-mm]'), ss = modal.querySelector('[data-bp-co-ss]');
    var deadline = Date.now() + minutes * 60000;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var left = Math.max(0, deadline - Date.now());
      if (left === 0) { decided = true; track('timeout'); goCheckout(); return; }
      mm.textContent = pad(Math.floor(left / 60000));
      var secs = pad(Math.floor((left % 60000) / 1000));
      if (ss.textContent !== secs) {
        ss.textContent = secs;
        ss.classList.remove('animate-change'); void ss.offsetWidth; ss.classList.add('animate-change');
      }
    }
    tick();
    countdown = setInterval(tick, 1000);
  }
  function show(d) {
    document.body.insertAdjacentHTML('beforeend', backgroundHtml(d) + modalHtml(d));
    var bg = document.querySelector('[data-bp-co-bg]'), modal = document.querySelector('[data-bp-co-modal]');
    document.documentElement.classList.add('bp-co-open');
    document.body.classList.add('bp-co-open');
    requestAnimationFrame(function () { bg.classList.remove('hide'); modal.classList.remove('hide'); });
    var addBtn = modal.querySelector('[data-bp-co-add]');
    addBtn.addEventListener('click', function (e) { e.preventDefault(); add(addBtn, d); });
    modal.querySelector('[data-bp-co-decline]').addEventListener('click', function (e) {
      e.preventDefault();
      e.currentTarget.disabled = true;
      decided = true;
      track('decline');
      goCheckout();
    });
    startCountdown(modal, d.minutes || 2);
    try { addBtn.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!t || t.disabled) return;
    track('tap');
    if (!wants()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    shown = true;
    open = true;
    track('shown');
    show(offer());
  }, true);
})();
